import type { ReactNode } from "react";

import { useLocalization } from "../hooks/useLocalization";
import { usePersistLanguage } from "../hooks/usePersistLanguage";
import { AVAILABLE_LANGUAGES } from "../constants/languages";

export type LanguageProfileMenuAction = {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  colorTitle?: "primary" | "red" | "green" | "yellow";
};

export const useLanguageProfileMenuActions = (): LanguageProfileMenuAction[] => {
  const { language } = useLocalization();
  const persistLanguage = usePersistLanguage();

  return AVAILABLE_LANGUAGES.map((item) => ({
    label: item.label,
    icon: (
      <img
        src={item.icon}
        alt=""
        width={16}
        height={16}
        className="rounded-sm object-cover"
      />
    ),
    onClick: () => {
      void persistLanguage(item.value).catch(() => undefined);
    },
    ...(language === item.value ? { colorTitle: "primary" as const } : {}),
  }));
};
